import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { WhitelabelService } from '../whitelabel.service';

@Component({
  selector: 'app-terms-privacy',
  templateUrl: './terms-privacy.component.html',
  styleUrls: ['./terms-privacy.component.scss'],
})
export class TermsPrivacyComponent {
  currentPopUpFrom: string;
  @Input() selectedStore: any; // To access store settings for custom URLs
  @ViewChild('readMoreSelectorModal') readMoreModal: ElementRef;
  constructor(
    public whitelabelService: WhitelabelService,
    private renderer: Renderer2,
  ) {}

  openReadMoreModal(event, from) {
    event.preventDefault();
    this.currentPopUpFrom = from;
    this.renderer.removeClass(this.readMoreModal.nativeElement, 'hide');
  }

  OnCheckOutsideClose() {
    this.currentPopUpFrom = '';
    this.renderer.addClass(this.readMoreModal.nativeElement, 'hide');
  }

  getEffectiveTermsUrl(): string {
    return (
      this.selectedStore?.settings?.CUSTOM_TERMS_URL ||
      this.whitelabelService.getWhiteLabelTermsLink()
    );
  }

  getEffectivePrivacyUrl(): string {
    return (
      this.selectedStore?.settings?.CUSTOM_PRIVACY_URL ||
      this.whitelabelService.getWhiteLabelPrivacyLink()
    );
  }

  getEffectiveRefundUrl(): string {
    return (
      this.selectedStore?.settings?.CUSTOM_REFUND_URL ||
      this.whitelabelService.getWhiteLabelRefundsLink()
    );
  }
}
